import React from 'react';
import { ExternalLink } from 'lucide-react';
import { mockAds } from '../mock/mockData';

const AdBanner = () => {
  const ad = mockAds[0]; // You can rotate ads or pick randomly

  return (
    <div className="px-4 sm:px-6 lg:px-8 my-12">
      <div className="relative rounded-lg overflow-hidden group cursor-pointer transition-transform hover:scale-[1.02] duration-300">
        {/* Background Image */}
        <img
          src={ad.image}
          alt={ad.title}
          className="w-full h-64 object-cover"
        />
        
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/60 to-transparent" />
        
        {/* Content */}
        <div className="absolute inset-0 flex flex-col justify-center px-12 space-y-4">
          <div className="inline-flex items-center space-x-2 w-fit">
            <span className="bg-yellow-500 text-black text-xs font-bold px-3 py-1 rounded">SPONSORED</span>
          </div>
          <h3 className="text-3xl md:text-4xl font-bold text-white max-w-xl">
            {ad.title}
          </h3>
          <p className="text-lg text-gray-200 max-w-lg">
            {ad.description}
          </p>
          <a
            href={ad.link}
            className="inline-flex items-center space-x-2 text-white hover:text-yellow-400 transition-colors w-fit group"
          >
            <span className="font-semibold">Learn More</span>
            <ExternalLink className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default AdBanner;